export const pointreport = {
  namespaced: true,
  state: {
    selectedPoint:null,
    loadingAsync: false,
    isOnline: true,
    syncProgress: { total: 0, done: 0 }
  },
  getters: {
  },
  actions: {
    
  },
  mutations: {
    setSelectedPoint(state,point){
      state.selectedPoint = point
    },

    setLoadingAsync(state, loading) {
      state.loadingAsync = loading
    },

    setIsOnline(state, online) {
      state.isOnline = online
    },

    setSyncProgress(state, progress) {
      state.syncProgress = progress
    }
  }
}